import React, { useEffect, useState } from "react";
import "./Birthday.css";
import ls from "local-storage";

export const LoginBirthdateCard = (props) => {
    // Handle Multiple Users
    const users = props.users || [];

    // Create comma-separated string of names
    let Name = "User";
    if (users.length > 0) {
        Name = users.map(u => u.firstName).join(" , ");
    } else {
        Name = props.name || (ls("user") ? ls("user").firstName : "User");
    }

    // Photo Cycling Logic
    const [photoIndex, setPhotoIndex] = useState(0);

    useEffect(() => {
        if (users.length > 1) {
            const interval = setInterval(() => {
                setPhotoIndex((prev) => (prev + 1) % users.length);
            }, 1500);
            return () => clearInterval(interval);
        }
    }, [users]);

    // Determine current photo
    const currentPhoto = users.length > 0 ? users[photoIndex].photo : props.photo;

    // Reset animation key on re-render
    const [key, setKey] = useState(0);
    useEffect(() => { setKey(prev => prev + 1); }, [Name]);

    return (
        <div className="birthday-card" key={key} onClick={() => setKey(prev => prev + 1)} style={{ cursor: 'pointer' }}>
            {/* Added 'login-card-mode' class for specific styling */}
            <div className="card login-card-mode">

                {/* Close Button */}
                <div className="close-btn" onClick={props.handleClose}>
                    &times;
                </div>

                {/* Confetti */}
                <div className="confetti-layer">
                    {[...Array(15)].map((_, i) => (
                        <div key={i} className={`confetti-piece c-${i + 1}`}></div>
                    ))}
                </div>

                {/* Cake Section (Left) */}
                <div className="cake-container">
                    <div className="cupcake">
                        <div className="cupcake-liner"></div>
                        <div className="muffin-top"></div>
                        <div className="frosting-stack">
                            <div className="frosting f-1"></div>
                            <div className="frosting f-2"></div>
                            <div className="frosting f-3"></div>
                            <div className="sprinkle s1"></div>
                            <div className="sprinkle s2"></div>
                            <div className="sprinkle s3"></div>
                            <div className="sprinkle s4"></div>
                            <div className="sprinkle s5"></div>
                        </div>
                        <div className="candle-spot">
                            <div className="magic-candle">
                                <div className="magic-flame"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Text Section (Right) */}
                <div className="magic-text">
                    {currentPhoto ? (
                        <div className="story-photo-wrapper">
                            <img key={photoIndex} src={currentPhoto} alt="Birthday User" className="story-profile-pic fade-photo" />
                        </div>
                    ) : null}

                    <div className="story-content-wrapper">
                        <h2 className="intro-text">It's a Special Day!</h2>
                        <div className="title-group">
                            <h1 className="name-reveal">
                                Happy Birthday, <br />
                                <span>{Name}</span>
                            </h1>
                        </div>
                        <div className="wish-note-container">
                            <p className="main-wish">
                                Have a fantastic day filled with joy!
                            </p>
                            <p className="sub-wish">Enjoy your day!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
